import React from 'react';

import { PRIMARY_COLOR } from '../constants/style-constants';
import { useCommon } from '../../store/CommonContext';

import './Subtitle.css';

interface Props {
  text: string | null;
  children?: React.ReactElement | null;
  additionalClasses?: string;
}

const Subtitle: React.FC<Props> = props => {
  const {
    state: { configuration },
  } = useCommon();
  const { text, children, additionalClasses } = props;

  return (
    <div
      className={`subtitle ${additionalClasses}`}
      style={configuration?.primaryColor ? { color: configuration.primaryColor as string } : undefined}
    >
      {children || text}
    </div>
  );
};

export default Subtitle;
